import { action, observable } from 'mobx';
import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { GenerateForm } from 'application/schedule/forms';
import { ScheduleService, OrderingScheduleService } from 'application/schedule/services';
import { FacilityService } from 'application/facility/services';
import _ from 'lodash';

class GenerateStore extends BaseViewStore {
    generateForm = new GenerateForm({
        onSuccess: async form => {
            await this.generate(form.values());
        }
    });

    @observable accessor deliveryCalendarSelected = false;
    @observable accessor orderingCalendarSelected = false;
    @observable accessor selectedCalendarTypes = [];

    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.deliveryCalendarSelected = componentProps.modalParams.data.deliveryCalendarSelected;
        this.orderingCalendarSelected = componentProps.modalParams.data.orderingCalendarSelected;
        const facilityId = this.modalParams.data.facilityId;
        if(facilityId)
            this.generateForm.set({facilityId: facilityId});

        this.calendarTypeId = componentProps.modalParams.data.calendarTypeId

        this.deliveryScheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        this.orderingScheduleService =  new OrderingScheduleService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        this.onCalendarChange = (item) => {
            item.selected = !item.selected;
            // if(e.target.id == 'delivery'){
            //     this.deliveryCalendarSelected = !this.deliveryCalendarSelected;
            // }else{
            //     this.orderingCalendarSelected = !this.orderingCalendarSelected;
            // }
        };

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 1000 });
                return response.data.item;
            },
            initValueFunc: facilityId
                ? async () => {
                    const response = await facilityService.get(facilityId);
                    return response.data;
                }
                : null
        });
    }

    @action.bound
    async generate(data) {
        this.generateForm.setFieldsDisabled(true);
        try {
            await this.deliveryScheduleService.generate(data);
            this.modalParams.close();
            this.rootStore.notificationStore.success('Schedule Dates successfully generated.');
        }
        catch (err) {
            this.generateForm.setFieldsDisabled(false);
            if (err.data)
                _.forEach(err.data, e => this.rootStore.notificationStore.error(e));
            else
                this.rootStore.notificationStore.error('Error occured while trying to generate Schedule Dates.')
        }
    }
}

export default GenerateStore;
